import { makeAutoObservable, runInAction } from "mobx";
import agent from "../../api/agent";
import { PagingParams } from "../../models/pagination";
import { SchematicListItem, SchematicRequest, SchematicSummary } from "../../models/Schematics/Schematic";

export default class SchematicStore {
    loading = false;
    totalCount: number = 0;
    pagingParams = new PagingParams(10, 0, "name");
    schematicItems: SchematicListItem[] = [];
    schematicItem: SchematicSummary | null = null;

    constructor() {
        makeAutoObservable(this);
    }

    setPagingParams = (pagingParams: PagingParams) => {
        this.pagingParams = pagingParams;
    }

    setPagination = (totalCount: number) => {
        this.totalCount = totalCount;
    }

    get axiosParams() {
        const params = new URLSearchParams();
        params.append('take', this.pagingParams.take.toString());
        params.append('skip', this.pagingParams.skip.toString());
        params.append('sort', this.pagingParams.sort);

        return params;
    }

    loadSchematicList = async (type: number = 0, name: string, includeModules: boolean, includeArtifacts: boolean, cat: string = '') => {
        this.loading = true;

        try {
            var axiosParams = this.axiosParams;

            if (type !== 0) {
                axiosParams.append('categoryId', type.toString());
            }

            if (name !== "") {
                axiosParams.append('name', name);
            }

            if (includeModules) {
                axiosParams.append('includeModules', "true");
            }

            if (includeArtifacts) {
                axiosParams.append('includeArtifacts', "true");
            }

            if (cat !== null && cat !== "") {
                axiosParams.append('category', cat);
            }

            const result = await agent.SchematicsApi.getList(axiosParams);

            runInAction(() => {
                this.schematicItems = result.data;
                this.setPagination(result.totalCount);
                this.loading = false;
            })
        } catch(error) {
            runInAction(() => this.loading = false);
            throw error;
        }
    }

    loadSchematic = async (slug: string, redMat: string = "none", locationId: number = 0) => {
        this.loading = true;

        try {
            const schematic = await agent.SchematicsApi.get(slug, redMat, locationId);

            runInAction(() => {
                this.schematicItem = schematic;
                this.loading = false;
            });
            
            return schematic;
        } catch(error) {
            runInAction(() => this.loading = false);
            throw error;
        }
    }

    uploadSchematics = async(form: FormData) => {
        try {
            console.log("form", form);

            await agent.SchematicsApi.process(form);
        } catch(error) {
            throw error;
        }
    }

    uploadSmrSchematics = async(form: FormData) => {
        try {
            console.log("form", form);

            await agent.SchematicsApi.processSmr(form);
        } catch(error) {
            throw error;
        }
    }

    uploadCorpSchematics = async(form: FormData) => {
        try {
            console.log("form", form);

            await agent.SchematicsApi.processCorp(form);
        } catch(error) {
            throw error;
        }
    }
}